import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { siteAPI } from '../../api/services';
import { categoryAPI } from '../../api/services';
import './Footer.css';

export default function Footer() {
  const [settings, setSettings] = useState(null);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (token) {
      siteAPI.getSettings()
        .then((res) => setSettings(res.data?.data || res.data || null))
        .catch(() => {});
    }

    categoryAPI.getAll()
      .then((res) => {
        const payload = res.data?.data || res.data;
        const list = Array.isArray(payload) ? payload : payload?.content;
        setCategories(Array.isArray(list) ? list : []);
      })
      .catch(() => {});
  }, []);

  const siteName = settings?.siteName || 'MiniMom Co';
  const siteDescription = settings?.siteDescription || 'Premium clothing for every style. Quality fabrics, modern designs.';
  const copyrightText = settings?.copyrightText || `© ${new Date().getFullYear()} MiniMom Co. All rights reserved.`;

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>{siteName}</h3>
          <p>{siteDescription}</p>
        </div>
        <div className="footer-section">
          <h4>Quick Links</h4>
          <Link to="/shop">Shop</Link>
          {categories.slice(0, 5).map((cat) => (
            <Link key={cat.id} to={`/categories/${cat.slug}`}>{cat.name}</Link>
          ))}
        </div>
        <div className="footer-section">
          <h4>Customer Service</h4>
          <Link to="/support">Contact Us</Link>
          <Link to="/orders">Track Order</Link>
          <Link to="/faq">FAQ</Link>
        </div>
        <div className="footer-section">
          <h4>Account</h4>
          <Link to="/account">My Account</Link>
          <Link to="/wishlist">Wishlist</Link>
          <Link to="/cart">Cart</Link>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-bottom-links">
          <Link to="/terms">Terms & Conditions</Link>
          <Link to="/privacy">Privacy Policy</Link>
        </div>
        <p>{copyrightText}</p>
      </div>
    </footer>
  );
}
